import { Reducer } from 'redux';
import { BpeState, BpeTypes } from './types';

const INITIAL_STATE: BpeState = {
  bpeConfigData: {
    id: '',
    privateKey: '',
    publicKey: '',
    pfx: '',
    certificatePassword: '',
    cityIBGECode: '',
    uf: '',
    ie: '',
    iest: '',
    im: '',
    cnae: '',
    crt: 1,
    tar: '',
    icms: '',
    icmsUFFim: '',
    transportType: 1,
    cfop: '',
    isMetropolitan: false,
    saleEmissionTypes: null,
    transportOperatorId: '',
    createdAt: '',
    updatedAt: '',
  },
  error: false,
  loading: false,
};

const reducer: Reducer<BpeState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES GET BPE CONFIG
    case BpeTypes.GET_BPE_CONFIG_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        bpeConfigData: INITIAL_STATE.bpeConfigData,
      };
    case BpeTypes.GET_BPE_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        bpeConfigData: action.payload.bpeConfigData,
      };
    case BpeTypes.GET_BPE_CONFIG_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        bpeConfigData: INITIAL_STATE.bpeConfigData,
      };

    // CASES UPDATE BPE CONFIG
    case BpeTypes.UPDATE_BPE_CONFIG_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        bpeConfigData: INITIAL_STATE.bpeConfigData,
      };
    case BpeTypes.UPDATE_BPE_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        bpeConfigData: action.payload.bpeConfigData,
      };
    case BpeTypes.UPDATE_BPE_CONFIG_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        bpeConfigData: INITIAL_STATE.bpeConfigData,
      };
    default:
      return state;
  }
};

export default reducer;
